<template>
  <div class="tw:flex tw:flex-col tw:h-full">
    <div class="tw:mb-auto">
      <h2 class="tw:font-bold tw:text-xl tw:mb-2">{{ $t('rc_opportunities_top_position_header') }}</h2>
      <p class="tw:text-sm">
        {{
          currentCommissionLevel === 25
            ? $t('rc_opportunities_highest_commission')
            : $t('rc_opportunities_top_position_subtext', {
                Percentage: formatPercentage(language, highestPossibleUpgrade, 0, 0),
              })
        }}
      </p>
    </div>
    <div>
      <CommissionLevelsGraph
        class="tw:mt-6"
        :class="categories.length === 6 ? 'tw:h-[500px]' : categories.length === 4 ? 'tw:h-[305px]' : 'tw:h-[390px]'"
        :series="series"
        :categories="categories"
        :colors="colors"
        @selectLevel="selectLevel"
      />
    </div>
  </div>
</template>
<script setup>
import CommissionLevelsGraph from '@/components/rateConnect/opportunityArea/commissionLevel/CommissionLevelsGraph.vue'

import { formatPercentage } from '@/utils/Utility.ts'
import { useSessionValues } from '@/composables/useSessionValues'

const emit = defineEmits(['selectLevel'])
const selectLevel = level => emit('selectLevel', level)
const { language } = useSessionValues()

defineProps({
  selectedCommissionLevel: Number,
  currentCommissionLevel: Number,
  highestPossibleUpgrade: Number,
  series: Object,
  categories: {
    type: Array,
    default: () => [],
  },
  colors: {
    type: Array,
    default: () => [],
  },
})
</script>
